import SelectAgency from "pages/Payments/SelectAgency";
import SelectMDA from "pages/Payments/SelectMDA";
import SelectRegion from "pages/Payments/SelectRegion";
import React, { useMemo } from "react";
import { Row, Col, Label, Input, FormFeedback } from "reactstrap";
import Flatpickr from "react-flatpickr";
import TimelineInput from "./TimelineInput";
import SelectRequestForm from "./SelectRequestForm";
// import SelectEntity from "./SelectEntity";
import SelectFile from "./SelectFile";
import { useProfile } from "Components/Hooks/UserHooks";
import { isAllowed } from "common/lib/permissionUtils";

const DefaultForm = ({ validation }: { validation: any }) => {
  const { userProfile } = useProfile();

  const canSelectAgency = useMemo(() => {
    return isAllowed(userProfile?.permissions, [
      {
        resource: "payment",
        action: "create",
      },
    ]);
  }, [userProfile?.permissions]);

  return (
    <>
      {/* <SelectRequestType validation={validation} /> */}
      <Row>
        <Col md={6} className="mb-3">
          <SelectRegion validation={validation} />
        </Col>
        <Col md={6} className="mb-3">
          <SelectMDA validation={validation} />
        </Col>
        {/* <Col md={3} className="mb-3">
          <SelectEntity validation={validation} />
        </Col> */}
        {canSelectAgency && (
          <Col md={6} className="mb-3">
            <SelectAgency validation={validation} />
          </Col>
        )}
        <Col md={3} className="mb-3">
          <Label htmlFor="dateOfRequest-field" className="form-label">
            Date of Request
          </Label>
          {/* @ts-ignore */}
          <Flatpickr
            name="dateOfRequest"
            id="dateOfRequest-field"
            className="form-control"
            placeholder="Select start date"
            options={{
              enableTime: false,
              altInput: false,
              altFormat: "d M, Y",
              dateFormat: "d M, Y",
            }}
            onChange={(e) => {
              validation.setFieldValue("dateOfRequest", e[0]);
            }}
            value={validation.values.dateOfRequest || ""}
          />
          {validation.touched.dateOfRequest &&
          validation.errors.dateOfRequest ? (
            <FormFeedback type="invalid">
              {validation.errors.dateOfRequest}
            </FormFeedback>
          ) : null}
        </Col>
        <Col md={3} className="mb-3">
          <Label htmlFor="totalValueOfRequest" className="form-label">
            Total Value of Request (USD)
          </Label>
          <Input
            type="number"
            name="totalValueOfRequest"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.totalValueOfRequest || ""}
            invalid={
              validation.touched.totalValueOfRequest &&
              validation.errors.totalValueOfRequest
            }
          />
          <FormFeedback>{validation.errors.totalValueOfRequest}</FormFeedback>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <TimelineInput validation={validation} />
        </Col>
        <Col md={6} className="mb-3">
          <Label htmlFor="nameOfRequester" className="form-label">
            Name of requester
          </Label>
          <Input
            name="nameOfRequester"
            id="nameOfRequester"
            className="form-control"
            placeholder="Enter name of requester"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.nameOfRequester || ""}
            invalid={
              validation.touched.nameOfRequester &&
              validation.errors.nameOfRequester
            }
          />
          <FormFeedback>{validation.errors.nameOfRequester}</FormFeedback>
        </Col>
      </Row>
      <Row>
        <Col md={6} className="mb-3">
          <Label htmlFor="objectiveOfRequest" className="form-label">
            Objective of Request
          </Label>
          <Input
            name="objectiveOfRequest"
            id="objectiveOfRequest"
            className="form-control"
            placeholder="Enter objective of request"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.objectiveOfRequest || ""}
            invalid={
              validation.touched.objectiveOfRequest &&
              validation.errors.objectiveOfRequest
            }
          />
          <FormFeedback>{validation.errors.objectiveOfRequest}</FormFeedback>
        </Col>
        <Col md={6} className="mb-3">
          <Label htmlFor="requestedSalary" className="form-label">
            Funding Status
          </Label>
          <select
            name="fundingStatus"
            id="fundingStatus"
            className="form-control"
            data-choices
            data-choices-search-false
            onChange={validation.handleChange}
            value={validation.values.fundingStatus}
          >
            <option value={""}>Select funding status</option>
            <option value={"In-progress"}>In-progress</option>
            <option value={"Pending"}>Pending</option>
            <option value={"Complete"}>Complete</option>
            <option value={"Denied"}>Denied</option>
          </select>
          <FormFeedback>{validation.errors.fundingStatus}</FormFeedback>
        </Col>
        <Col md={6} className="mb-3">
          <SelectRequestForm validation={validation} />
        </Col>
        <Col md={6} className="mb-3">
          <Label htmlFor="contactPerson" className="form-label">
            Contact Person
          </Label>
          <Input
            type="text"
            name="contactPerson"
            id="contactPerson"
            placeholder="Enter contact person name"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.contactPerson || ""}
            invalid={
              validation.touched.contactPerson &&
              validation.errors.contactPerson
            }
          />
          <FormFeedback>{validation.errors.contactPerson}</FormFeedback>
        </Col>
      </Row>
      <Row>
        <Col md={6} className="mb-3">
          <Label htmlFor="expectedOutputs" className="form-label">
            Expected Outputs
          </Label>
          <Input
            type="textarea"
            name="expectedOutputs"
            id="expectedOutputs"
            rows={4}
            placeholder="Enter expected outputs"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.expectedOutputs || ""}
            invalid={
              validation.touched.expectedOutputs &&
              validation.errors.expectedOutputs
            }
          />
          <FormFeedback>{validation.errors.expectedOutputs}</FormFeedback>
        </Col>
        <Col md={6} className="mb-3">
          <Label htmlFor="requestDescription" className="form-label">
            Additional Details
          </Label>
          <Input
            type="textarea"
            name="additionalDetails"
            id="additionalDetails"
            rows={4}
            placeholder="Enter additional details"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.additionalDetails || ""}
            invalid={
              validation.touched.additionalDetails &&
              validation.errors.additionalDetails
            }
          />
          <FormFeedback>{validation.errors.additionalDetails}</FormFeedback>
        </Col>
        <Col md={12} className="mb-3">
          <SelectFile validation={validation} />
        </Col>
      </Row>
    </>
  );
};

export default DefaultForm;
